import classNames from 'classnames';
import CurrencyFormat from 'react-currency-format';
import styles from './VariationBoxIndicator.module.scss';

export interface IVariationBoxIndicator {
  value: number | null;
  className?: string;
  suffix?: string;
  prefix?: string;
  positiveValueIsGood?: boolean;
}

export const VariationBoxIndicator = ({ value, className, prefix, suffix = '' }: IVariationBoxIndicator) => {
  if (Number.isNaN(value) || value === null || value === Infinity || value === -Infinity) return <>--</>;

  if (value === 0) {
    return <div className={classNames(styles.box, className)}>SEM VAR.</div>;
  }

  const isValuePositive = value > 0;

  return (
    <CurrencyFormat
      className={classNames(styles.box, isValuePositive ? styles['box-positive'] : styles['box-negative'], className)}
      value={value}
      displayType="text"
      decimalScale={1}
      // `prefix ?? (...)`, e nao `prefix || ... ? ... : ...`: naquela forma o `||` e avaliado
      // ANTES do ternario, e qualquer prefixo recebido vira condicao verdadeira, fazendo o sinal
      // sair '+ ' mesmo numa variacao negativa.
      prefix={prefix ?? (isValuePositive ? '+ ' : '- ')}
      suffix={suffix}
      fixedDecimalScale
      allowNegative={false}
    />
  );
};
